// DeleteConfirmationDialog.js

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

export default function ConfirmationDialog({
  open,
  title,
  content,
  onClose,
  onCancel,
  onDelete,
  showCancel = false,
  showDelete = false,
}) {
  const handleDelete = () => {
    onDelete();
    onClose();
  };

  return (
    <Dialog open={Boolean(open)} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        {showCancel && <Button onClick={onCancel}>Cancel</Button>}
        {showDelete && (
          <Button onClick={handleDelete} color="error">
            Delete
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
